import { Injectable } from '@angular/core';
import { ProductCategoriesModel } from '../../../models/master-data/product-categories.model';
import {BaseService} from '../../../shared/services/base.service';
import {ProductCategoryUrl} from '../../../shared/urls/master-data.productcategory.url';
@Injectable()
export class ProductCategoriesService {
    constructor(public baseService: BaseService) {

    }

    getProductCategoryList(param) {
        const url = ProductCategoryUrl.PRODUCTCATEGORY_GET;
        return this.baseService.getData(url, param);
    }

    getProductCategoryDetail(Id) {
        const url = ProductCategoryUrl.PRODUCTCATEGORY_DETAIL + `${Id}`;
        return this.baseService.getById(url, Id);
    }

    addProductCategory(param) {
        const url = ProductCategoryUrl.PRODUCTCATEGORY_ADD;
        return this.baseService.post(url, param);
    }
    updateProductCategory(id, param) {
        const url = ProductCategoryUrl.PRODUCTCATEGORY_UPDATE + `${id}`;
        return this.baseService.put(url, param);
    }
    removeProductCategory(id) {
        const url = ProductCategoryUrl.PRODUCTCATEGORY_DELETE.replace('{id}',id);
        return this.baseService.delete(url);
    }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/product-categories/product-categoriest.service.ts